<nz-transfer class="container"
      [nzDataSource]="list"
      [nzListStyle]="{ 'width.px': 250, 'height.px': 500 }"
      nzShowSearch
      [nzFilterOption]="filterOption"
      (nzSearchChange)="search($event)"
      (nzSelectChange)="select($event)"
      (nzChange)="change($event)"
    >
    </nz-transfer>
